import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import SolutionsPage from './pages/SolutionsPage'
import AboutPage from './pages/AboutPage'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import Contact from './pages/Contact'
import Support from './pages/Support'
import LegalPage from './pages/LegalPage'
import Login from './pages/Login'
import AuthMagic from './pages/AuthMagic'
import Portal from './pages/Portal'
import PortalTicket from './pages/PortalTicket'
import Admin from './pages/Admin'
import AuthGate from './components/auth/AuthGate'
import ScrollToTop from './components/ScrollToTop'
import CookieConsent from './components/CookieConsent'
import BackToTop from './components/BackToTop'
import SkipToContent from './components/SkipToContent'

function App() {
  const { i18n } = useTranslation()

  useEffect(() => {
    // Set HTML lang attribute
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  return (
    <Router>
      <ScrollToTop />
      <SkipToContent />
      <div className="min-h-screen bg-background-light dark:bg-background-dark text-slate-800 dark:text-slate-200 transition-colors duration-300">
        <Navbar />
        <main id="main-content" tabIndex={-1}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/support" element={<Support />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/magic" element={<AuthMagic />} />
            <Route
              path="/portal"
              element={
                <AuthGate require="customer">
                  <Portal />
                </AuthGate>
              }
            />
            <Route
              path="/portal/tickets/:id"
              element={
                <AuthGate require="customer">
                  <PortalTicket />
                </AuthGate>
              }
            />
            <Route
              path="/admin"
              element={
                <AuthGate require="admin">
                  <Admin />
                </AuthGate>
              }
            />
            <Route path="/mentions-legales" element={<LegalPage />} />
            <Route path="/rgpd" element={<LegalPage />} />
            <Route path="/cookies" element={<LegalPage />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <BackToTop />
      </div>
    </Router>
  )
}

export default App
